import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Core components
import Badge from 'components/core/Badge';
import Card from 'components/core/Card';
import Typography from 'components/core/Typography';
// Custom
import { MulticriteriaTextButton, ResetTextButton } from 'components/buttons/TextButtons';

const FiltersTemplate = ({
  disabled, advanced, nbFiltersApplied, children, onReinit, onSwitch, defaultBackground, expandable,
}) => {
  // Manage expanded state
  const [expanded, setExpanded] = React.useState(true);
  const handleExpand = (e) => {
    setExpanded(e);
  };

  return (
    <Card
      outlined
      defaultBackground={defaultBackground}
      padding="none"
      actions={[
        <div className="d-flex align-items-center justify-content-between w-100 pl-2" key="fActions">
          <div className="d-flex align-items-cente">
            {!expanded && (
              nbFiltersApplied > 0 ? (
                <Badge content={nbFiltersApplied} gap="large">
                  <Typography type="subtitle2">
                    <LocalizedMessage id="title.filters" />
                  </Typography>
                </Badge>
              ) : (
                <Typography type="subtitle2">
                  <LocalizedMessage id="title.filters" />
                </Typography>
              )
            )}
          </div>
          <div className="d-flex align-items-center right-spaced-buttons" key="filterActions">
            {!advanced && expanded && (
            <MulticriteriaTextButton size="small" disabled={disabled} onClick={onSwitch} />
            )}
            <ResetTextButton size="small" disabled={disabled || nbFiltersApplied === 0} onClick={onReinit} />
          </div>
        </div>,
      ]}
      expandFromActions={expandable}
      onExpand={expandable ? handleExpand : undefined}
    >
      <div
        className={
              classnames('d-flex px-3 row', {
                'justify-content-end': !advanced,
              })
            }
      >
        {children}
      </div>
    </Card>
  );
};

FiltersTemplate.propTypes = {
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
  defaultBackground: PropTypes.bool,
  expandable: PropTypes.bool,
};

FiltersTemplate.defaultProps = {
  defaultBackground: true,
  expandable: true,
};

module.exports = FiltersTemplate;



// WEBPACK FOOTER //
// ./components/templates/FiltersCardTemplate.js